import React, { useEffect, Dispatch, SetStateAction } from "react";
import { Form, Button, Col, Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { faInstagram } from "@fortawesome/free-brands-svg-icons";
import LoadingContent from "../../LoadingContent";
import { countryCodeToFlag } from "../../../utils/Admin";

interface InstagramProps {
  data: any;
  instagramEmbed: string;
  setInstagramEmbed: Dispatch<SetStateAction<string>>;
  onIndividualSubmit: () => void; // Recibido del padre para envío 1 a 1
  uploading: boolean; // Recibido del padre para el spinner individual
}

const NewsInstagram = ({
  data,
  instagramEmbed,
  setInstagramEmbed,
  onIndividualSubmit,
  uploading,
}: InstagramProps) => {
  const MAX_CHARS = 2200;

  const charCount = instagramEmbed.length;
  const isOverLimit = charCount > MAX_CHARS;

  const getRaceName = (length: number, type_race: number) => {
    if (length === 2 && type_race === 1) return "Main Race";
    else if (length === 2 && type_race === 2) return "Sprint Race";
  };

  useEffect(() => {
    if (!data) return;

    setInstagramEmbed([`a`].join("\n"));
  }, [data, setInstagramEmbed]);

  if (data == null) return <LoadingContent />;

  return (
    // Cambiado de <Form> a un <div> plano para integrarse con el padre
    <div className="instagram-form mb-4 p-3 border rounded shadow-sm">
      <Row className="mb-3">
        <Form.Group className="form-group col-md-12">
          <h4>
            <FontAwesomeIcon
              icon={faInstagram}
              className="me-2"
              style={{ color: "#E1306C" }}
            />
            Instagram [Including GP Image]
          </h4>
        </Form.Group>

        <Form.Group className="form-group" as={Col} md="12">
          <div
            style={{
              marginTop: "6px",
              fontSize: "13px",
              textAlign: "right",
              color: isOverLimit ? "red" : "#e2e2e2",
              fontWeight: isOverLimit ? "bold" : "normal",
            }}
          >
            {charCount} / {MAX_CHARS}
          </div>
          <Form.Label>Post (*)</Form.Label>
          <Form.Control
            required
            as="textarea"
            name="instagram_embed"
            rows={6}
            value={instagramEmbed}
            onChange={(e) => setInstagramEmbed(e.target.value)}
            isInvalid={isOverLimit}
          />
          <Form.Control.Feedback type="invalid">
            Field required o excess characters
          </Form.Control.Feedback>
        </Form.Group>
      </Row>

      {/* Botón para enviar ÚNICAMENTE Instagram */}
      <div className="text-center">
        {uploading ? (
          <FontAwesomeIcon icon={faSpinner} className="spinner-button" spin />
        ) : (
          <Button
            type="button" // Evita que se ejecute el onSubmit global del padre
            variant="secondary"
            onClick={onIndividualSubmit}
            disabled={isOverLimit}
          >
            Send Instagram Post Only
          </Button>
        )}
      </div>
    </div>
  );
};

export default NewsInstagram;
